/** Must match howfactory-api `src/constants/auth-errors.ts` codes for branching. */
export const AUTH_ERROR_CODES = {
  REGISTER_EMAIL_USES_GOOGLE: 'REGISTER_EMAIL_USES_GOOGLE',
  LOGIN_REQUIRES_GOOGLE: 'LOGIN_REQUIRES_GOOGLE',
  GOOGLE_SIGNIN_EMAIL_HAS_PASSWORD: 'GOOGLE_SIGNIN_EMAIL_HAS_PASSWORD',
  GOOGLE_ACCOUNT_MISMATCH: 'GOOGLE_ACCOUNT_MISMATCH',
  GOOGLE_BIND_EMAIL_MISMATCH: 'GOOGLE_BIND_EMAIL_MISMATCH',
  GOOGLE_BIND_ALREADY_LINKED: 'GOOGLE_BIND_ALREADY_LINKED',
  INVITATION_NOT_FOUND: 'INVITATION_NOT_FOUND',
  INVITATION_EXPIRED: 'INVITATION_EXPIRED',
  INVITATION_EMAIL_MISMATCH: 'INVITATION_EMAIL_MISMATCH'
} as const

/** Codes returned by API when an invitationToken-bearing SSO call must abort the entire flow.
 *  Derived from AUTH_ERROR_CODES so renaming a key surfaces a typecheck error here.
 *  Typed as `ReadonlyArray<string>` so `.includes(code)` works when `code` is a plain string. */
export const INVITATION_ABORT_CODES: ReadonlyArray<string> = [
  AUTH_ERROR_CODES.INVITATION_NOT_FOUND,
  AUTH_ERROR_CODES.INVITATION_EXPIRED,
  AUTH_ERROR_CODES.INVITATION_EMAIL_MISMATCH
]
